
































import Vue from 'vue';
import HMButton from '@/web/components/common/HMButton';
import { notify } from '@/web/utils/notify';
import HMWidgetCodeModal from '@/web/components/widgets/HMWidgetCodeModal.vue';

export default Vue.extend({
  name: 'HMWidgetCard',
  components: { HMButton },
  props: {
    title: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
  },
  methods: {
    copy(value: string): void {
      this.$copyText(value).then(() => {
        notify(this.$t('PRODUCTS.TOAST.COPIED') as string, this.title);
      });
    },
    showCodeModal() {
      this.$modal.show(HMWidgetCodeModal, {
        code: this.code,
        title: this.title,
      });
    },
  },
});
